export default __webpack_public_path__ + "static/media/userWhite.ab380863.svg";